import { GET_SALE_POINT_CATEGORIES, convertResult, convertParams } from 'app/common/api/requests/food/schools/sale_points/categories/get'
import { SalePointCategoriesParams, SalePointCategories } from 'app/common/types/sale-points/categories'

import { useCommonDataProvider, Options } from 'app/dataProviders/useCommonDataProvider'


const defaultState: SalePointCategories = {
  categoriesIds: [],
  useComplexes: false,
  limitSingleItemInPurchase: null,
}

type Op = Omit<Options<
  SalePointCategories,
  SalePointCategoriesParams
>, 'requestValue' | 'convertions' | 'defaultState'>

export function useSalePointCategories(options: Op = {} as Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_SALE_POINT_CATEGORIES,
    error: 'Не удалось получить список категорий для точки продаж',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  return res
}
